import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import EnvironmentBanner from "./EnvironmentBanner";
import HelpButton from "./HelpButton";

function Layout() {
  const location = useLocation();

  // Don't show bottom nav on login, query list, and chat window pages
  const hideBottomNav =
    location.pathname === "/login" ||
    location.pathname === "/queries" ||
    location.pathname.startsWith("/chat/");

  // Don't show help button on login page
  const hideHelpButton = location.pathname === "/login";

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 transition-colors duration-300">
      <EnvironmentBanner />
      <Outlet />
      {!hideBottomNav && <BottomNav />}
      {!hideHelpButton && <HelpButton />}
    </div>
  );
}

export default Layout;
